
import BriefingDetailContainer from 'containers/BriefingDetailContainer';

export default (props: any) => (
  <BriefingDetailContainer {...props} edit={true} />
);
